// Antalya ilçe bazlı landing page içerikleri
// Her ilçe için: başlık, meta, hero, detaylı içerik, yerel özellikler

export const ilceler = {
  "antalya-psikolog": {
    slug: "antalya-psikolog",
    ilce: "Antalya",
    h1: "Antalya Psikolog — Uzm. Klinik Psikolog Aysun Şeremet",
    title: "Antalya Psikolog | Uzm. Klinik Psikolog Aysun Şeremet - EMDR & Online Terapi",
    description:
      "Antalya'da Uzm. Klinik Psikolog Aysun Şeremet ile bireysel, çocuk, ergen ve aile terapisi. EMDR, BDT, Şema Terapi ekollerinde online ve yüz yüze seanslar. Randevu: 0537 215 34 07.",
    keywords:
      "antalya psikolog, antalya klinik psikolog, antalya psikolog aysun seremet, antalya terapi, antalya psikoterapi, antalya emdr, antalya psikolojik danışmanlık",
    heroIntro:
      "Antalya'da, hayatınızın zorlu dönemlerinde yanınızda olmak için buradayım. Bireysel, çocuk, ergen ve aile danışmanlığında bilimsel temelli bir yaklaşımla çalışıyorum.",
    lat: 36.8969,
    lng: 30.7133,
    areaServed: ["Muratpaşa", "Konyaaltı", "Kepez", "Aksu", "Döşemealtı", "Serik", "Manavgat", "Alanya"],
    sections: [
      {
        title: "Antalya'da Psikolog Seçerken Nelere Dikkat Etmelisiniz?",
        body:
          "Antalya'nın hızlı yaşam temposu, turizm kaynaklı sezonsal yoğunluk ve büyüyen nüfus; bireylerin psikolojik ihtiyaçlarını farklılaştırıyor. Doğru uzmanı seçerken şu kriterlere dikkat etmek önemlidir: uzmanın eğitim geçmişi, süpervizyon almış olması, çalıştığı ekoller (EMDR, BDT, Şema Terapi gibi), etik ilkeler ve gizlilik standartları. Uzm. Klinik Psikolog Aysun Şeremet; yüksek lisans eğitimini klinik psikoloji alanında tamamlamış, EMDR, Bilişsel Davranışçı Terapi ve Şema Terapi ekollerinde çalışan bir uzmandır.",
      },
      {
        title: "Antalya'da Hangi Hizmetler Sunuluyor?",
        body:
          "Bireysel terapi, aile danışmanlığı, çocuk-ergen psikolojik desteği, sınav kaygısı (YKS/LGS) ile çalışma, panik atak ve kaygı bozuklukları, depresyon, travma sonrası stres bozukluğu (TSSB), ilişki ve bağlanma sorunları. Her birey için süreç, ilk görüşmede birlikte planlanır. Seanslar 50 dakika sürer ve genellikle haftada bir yapılır; ancak kişinin ihtiyacına göre sıklık düzenlenebilir.",
      },
      {
        title: "Antalya'nın Tüm İlçelerine Hizmet",
        body:
          "Muratpaşa, Konyaaltı, Kepez, Aksu, Döşemealtı merkez ilçelerinin yanı sıra Serik, Manavgat, Alanya, Kaş, Kemer ve Kumluca gibi uzak ilçelerden de danışanlara online seans imkânı sunuyoruz. Yüz yüze seanslar kliniğimizde; online seanslar ise güvenli video görüşme platformları üzerinden gerçekleştirilmektedir.",
      },
      {
        title: "Online mı Yüz Yüze mi?",
        body:
          "Her iki yöntem de etkindir. Yüz yüze seanslar; beden dili, ortamın güveni ve ritüel sayesinde bazı danışanlar için tercih edilir. Online seanslar ise; ulaşım yorgunluğu olmayan, yoğun iş hayatı olan, Antalya dışında yaşayan (ya da Kaş, Alanya gibi uzak ilçelerde oturan), küçük çocuklu ebeveyn olan ya da anksiyete nedeniyle dışarı çıkmakta zorlanan kişiler için büyük kolaylık sağlar. İlk görüşmede hangi formatın size daha uygun olacağını birlikte değerlendiriyoruz.",
      },
    ],
  },

  "muratpasa-psikolog": {
    slug: "muratpasa-psikolog",
    ilce: "Muratpaşa",
    h1: "Muratpaşa Psikolog — Uzm. Klinik Psikolog Aysun Şeremet",
    title: "Muratpaşa Psikolog | Uzm. Klinik Psikolog - EMDR & Terapi Antalya Muratpaşa",
    description:
      "Antalya Muratpaşa psikolog arayanlar için bireysel, çocuk, ergen ve aile terapisi. EMDR, BDT ve Şema Terapi ekolleri. Online ve yüz yüze seanslar. Randevu: 0537 215 34 07.",
    keywords:
      "muratpaşa psikolog, antalya muratpaşa psikolog, muratpaşa klinik psikolog, muratpaşa terapi, muratpaşa emdr, muratpaşa aile danışmanı",
    heroIntro:
      "Antalya'nın kalbinde, Muratpaşa'da yaşayan bireyler, çiftler ve aileler için bilimsel temelli psikolojik destek sunuyorum.",
    lat: 36.8841,
    lng: 30.7056,
    areaServed: ["Muratpaşa", "Lara", "Kaleiçi", "Meltem", "Gürsu"],
    sections: [
      {
        title: "Muratpaşa'da Psikolojik Destek",
        body:
          "Muratpaşa; Antalya'nın en yoğun ilçelerinden biri. Lara, Kaleiçi, Meltem, Gürsu gibi mahallelerinde yaşayan bireyler; iş stresi, ilişki sorunları, ebeveynlik kaygıları ve sezonsal yaşam tarzı kaynaklı duygusal dalgalanmalarla başa çıkmakta zorlanabilir. Uzm. Klinik Psikolog Aysun Şeremet; Muratpaşa ve çevresindeki danışanlara EMDR, BDT ve Şema Terapi gibi kanıta dayalı yöntemlerle destek olmaktadır.",
      },
      {
        title: "Hangi Durumlarda Destek Alabilirsiniz?",
        body:
          "Panik atak ve yaygın kaygı bozukluğu, depresyon, iş tükenmişliği, romantik ilişki krizleri, evlilik sorunları, çocuğunuzun uyum ve davranış problemleri, ergen çatışmaları, sınav kaygısı (LGS/YKS), kayıp ve yas süreçleri, travma sonrası stres belirtileri. Süreç, ilk görüşmede ihtiyacınıza göre birlikte planlanır.",
      },
      {
        title: "Ulaşım ve Seans Seçenekleri",
        body:
          "Yüz yüze seanslar kliniğimizde gerçekleştirilmektedir. Muratpaşa merkez ve çevre semtlerden (Konyaaltı, Kepez) kolay ulaşım sağlanır. Online seanslar ise güvenli video platformları üzerinden; iş çıkışı, öğle arası veya hafta sonu saatlerinde esnek planlanabilir.",
      },
    ],
  },

  "konyaalti-psikolog": {
    slug: "konyaalti-psikolog",
    ilce: "Konyaaltı",
    h1: "Konyaaltı Psikolog — Uzm. Klinik Psikolog Aysun Şeremet",
    title: "Konyaaltı Psikolog | Uzm. Klinik Psikolog - Antalya Konyaaltı Terapi",
    description:
      "Antalya Konyaaltı psikolog ve aile danışmanlığı. Bireysel, çocuk ve ergen terapisi. EMDR, BDT, Şema Terapi. Online ve yüz yüze. Randevu: 0537 215 34 07.",
    keywords:
      "konyaaltı psikolog, antalya konyaaltı psikolog, konyaaltı klinik psikolog, konyaaltı terapi, konyaaltı aile danışmanı, konyaaltı çocuk psikoloğu",
    heroIntro:
      "Konyaaltı'nda yaşayan bireyler, çiftler ve aileler için güvenli, yargısız ve bilimsel bir danışmanlık sürecinde yanınızdayım.",
    lat: 36.8676,
    lng: 30.6370,
    areaServed: ["Konyaaltı", "Liman", "Hurma", "Arapsuyu", "Pınarbaşı"],
    sections: [
      {
        title: "Konyaaltı'nda Psikolojik Danışmanlık",
        body:
          "Konyaaltı; deniz, doğa ve modern yaşamın buluştuğu, yoğun bir aile nüfusuna ev sahipliği yapan bir bölgedir. Liman, Hurma, Arapsuyu, Pınarbaşı gibi mahallelerinde yaşayan bireylerin yaşam kalitesi yüksek olsa da; iş-aile dengesi, ebeveynlik kaygısı, evlilik dinamikleri ve çocukların akademik süreçleri gibi konularda profesyonel destek ihtiyacı doğabilir.",
      },
      {
        title: "Çift ve Aile Danışmanlığı",
        body:
          "Ebeveynlik farkları, aile içi çatışmalar ve aile içi iletişim süreçleri hassasiyetle ele alınmaktadır. Aile danışmanlığında amaç 'kimin haklı olduğunu' bulmak değil; tarafların birbirini daha iyi anlamasını ve sağlıklı iletişim kalıpları geliştirmesini desteklemektir.",
      },
      {
        title: "Çocuk ve Ergen Süreci",
        body:
          "Konyaaltı'ndaki okul çağı çocukları ve ergenler için uyum, kaygı, öfke yönetimi, akran ilişkileri ve sınav kaygısı gibi konularda çalışmalar yürütülmektedir. Süreçte ebeveynlerle iş birliği içinde, çocuğun yaş ve gelişim düzeyine uygun yöntemler kullanılır.",
      },
    ],
  },

  "kepez-psikolog": {
    slug: "kepez-psikolog",
    ilce: "Kepez",
    h1: "Kepez Psikolog — Uzm. Klinik Psikolog Aysun Şeremet",
    title: "Kepez Psikolog | Uzm. Klinik Psikolog - Antalya Kepez Terapi",
    description:
      "Antalya Kepez psikolog hizmeti. Bireysel, çocuk, ergen ve aile terapisi. EMDR, BDT, Şema Terapi ekolleri. Online ve yüz yüze. Randevu: 0537 215 34 07.",
    keywords:
      "kepez psikolog, antalya kepez psikolog, kepez klinik psikolog, kepez terapi, kepez aile danışmanı, kepez çocuk psikoloğu",
    heroIntro:
      "Kepez'de yaşayan bireyler ve aileler için güvenli ve bilimsel temelli bir psikolojik danışmanlık süreci sunuyorum.",
    lat: 36.9220,
    lng: 30.7136,
    areaServed: ["Kepez", "Varsak", "Sütçüler", "Güzelbağ", "Odabaşı"],
    sections: [
      {
        title: "Kepez'de Psikolog",
        body:
          "Kepez; Antalya'nın en kalabalık ilçelerinden biri olarak geniş bir aile ve genç nüfusa sahiptir. Varsak, Sütçüler, Güzelbağ gibi mahallelerde yaşayan danışanlar; kaygı bozuklukları, depresyon, ebeveynlik zorlukları ve ergenlik dönemi problemlerinde Uzm. Klinik Psikolog Aysun Şeremet'ten destek alabilir.",
      },
      {
        title: "Sık Karşılaşılan Konular",
        body:
          "Panik atak, yaygın kaygı, sosyal fobi, depresyon belirtileri, çift içi geçimsizlik, ergen-ebeveyn çatışmaları, çocukta okula uyum problemleri ve LGS/YKS sınav kaygısı. Her biri için ekole uygun, kanıta dayalı yöntemler (EMDR, BDT, Şema Terapi) uygulanır.",
      },
      {
        title: "Online Seans Avantajı",
        body:
          "Kepez'den uzak mahallelerde yaşayan, iş yoğunluğu nedeniyle yüz yüze seans için vakit ayıramayan ya da küçük çocuklu ebeveynler için online seanslar pratik bir çözümdür. Güvenli görüntülü görüşme platformları üzerinden yapılır.",
      },
    ],
  },

  "aksu-psikolog": {
    slug: "aksu-psikolog",
    ilce: "Aksu",
    h1: "Aksu Psikolog — Uzm. Klinik Psikolog Aysun Şeremet",
    title: "Aksu Psikolog | Uzm. Klinik Psikolog - Antalya Aksu Terapi",
    description:
      "Antalya Aksu psikolog ve aile danışmanlığı. Bireysel, çocuk ve ergen terapisi. EMDR, BDT, Şema Terapi. Online ve yüz yüze. Randevu: 0537 215 34 07.",
    keywords:
      "aksu psikolog, antalya aksu psikolog, aksu klinik psikolog, aksu terapi, aksu aile danışmanı",
    heroIntro:
      "Aksu'da yaşayan bireyler ve aileler için online ve yüz yüze psikolojik danışmanlık hizmeti.",
    lat: 36.9381,
    lng: 30.8381,
    areaServed: ["Aksu", "Altıntaş", "Kundu", "Pınarlı"],
    sections: [
      {
        title: "Aksu'da Psikolojik Destek",
        body:
          "Aksu; Antalya'nın doğu aksında, hızla büyüyen bir ilçedir. Aile yapısının ağırlıklı olduğu bölgede; ebeveynlik sorunları, çocuk gelişimi, evlilik içi iletişim ve iş stresi temel başvuru konuları arasındadır.",
      },
      {
        title: "Uzaktan Danışmanlık Kolaylığı",
        body:
          "Aksu'dan şehir merkezine ulaşım bazı danışanlar için zaman kaybı olabilir. Online seanslar; evinizin ya da iş yerinizin konforunda, güvenli platformlar üzerinden aynı etkiyle gerçekleştirilir.",
      },
      {
        title: "Çalışma Konuları",
        body:
          "Kaygı ve depresyon, çift ve aile sorunları, çocuk-ergen uyum problemleri, sınav kaygısı, travma sonrası stres, ilişki ve bağlanma örüntüleri.",
      },
    ],
  },

  "dosemealti-psikolog": {
    slug: "dosemealti-psikolog",
    ilce: "Döşemealtı",
    h1: "Döşemealtı Psikolog — Uzm. Klinik Psikolog Aysun Şeremet",
    title: "Döşemealtı Psikolog | Uzm. Klinik Psikolog - Antalya Döşemealtı Terapi",
    description:
      "Antalya Döşemealtı psikolog hizmeti. Bireysel, çocuk, ergen ve aile terapisi. EMDR, BDT, Şema Terapi. Online ve yüz yüze. Randevu: 0537 215 34 07.",
    keywords:
      "döşemealtı psikolog, antalya döşemealtı psikolog, döşemealtı klinik psikolog, döşemealtı terapi, döşemealtı aile danışmanı",
    heroIntro:
      "Döşemealtı'nda yaşayan bireyler ve aileler için güvenli, bilimsel temelli psikolojik destek.",
    lat: 37.0280,
    lng: 30.5926,
    areaServed: ["Döşemealtı", "Yeşilbayır", "Kömürcüler", "Karataş"],
    sections: [
      {
        title: "Döşemealtı'nda Psikolog",
        body:
          "Döşemealtı; sakin yaşam tarzı ve doğayla iç içe yapısıyla bilinse de; ebeveynlik zorlukları, çocukların akademik süreci, aile içi iletişim ve modern yaşamın kaygıları burada da yaşanmaktadır. Uzm. Klinik Psikolog Aysun Şeremet, bölgedeki ailelere ve bireylere EMDR, BDT ve Şema Terapi yaklaşımlarıyla destek sunmaktadır.",
      },
      {
        title: "Çocuk ve Aile Odaklı Yaklaşım",
        body:
          "Özellikle çocuk ve ergen danışanlar için yaş ve gelişim düzeyine uygun, oyun ve etkileşim temelli yöntemler kullanılır. Ebeveynlerle iş birliği sürecin vazgeçilmez parçasıdır.",
      },
      {
        title: "Seans Opsiyonları",
        body:
          "Yüz yüze seanslar klinikte; online seanslar güvenli video platformları üzerinden. Her iki yöntem de aynı etik ilkeler ve gizlilik standartlarıyla yürütülmektedir.",
      },
    ],
  },

  "online-psikolog-antalya": {
    slug: "online-psikolog-antalya",
    ilce: "Online (Antalya ve Tüm Türkiye)",
    h1: "Online Psikolog Antalya — Uzm. Klinik Psikolog Aysun Şeremet",
    title: "Online Psikolog Antalya | Uzm. Klinik Psikolog - Video Görüşme Terapi",
    description:
      "Antalya ve tüm Türkiye'den online psikolojik danışmanlık. Güvenli video platformlarında bireysel, çocuk, ergen ve aile terapisi. EMDR, BDT, Şema Terapi. Randevu: 0537 215 34 07.",
    keywords:
      "online psikolog antalya, antalya online terapi, online psikolog, video görüşme psikolog, online psikolojik danışmanlık, online emdr terapi",
    heroIntro:
      "Nerede olursanız olun, güvenli video görüşme üzerinden profesyonel psikolojik destek. Antalya'nın her ilçesinden, Türkiye'nin her şehrinden ve yurt dışından katılımla online seanslar.",
    lat: 36.8969,
    lng: 30.7133,
    areaServed: ["Türkiye", "Antalya", "Avrupa", "Dünya"],
    sections: [
      {
        title: "Online Terapi Nedir, Nasıl İşler?",
        body:
          "Online terapi; güvenli ve şifreli görüntülü görüşme platformları üzerinden yürütülen, yüz yüze seansla aynı etkinliğe sahip bir danışmanlık yöntemidir. Araştırmalar; online terapinin kaygı, depresyon, ilişki sorunları ve travma işlemede yüz yüze terapiyle benzer sonuçlar verdiğini göstermektedir.",
      },
      {
        title: "Kimler İçin Uygundur?",
        body:
          "Antalya'nın uzak ilçelerinde yaşayanlar (Kaş, Alanya, Kemer, Kumluca), yurt dışında yaşayan Türkler, yoğun iş hayatı olan profesyoneller, küçük çocuklu ebeveynler, ulaşım güçlüğü yaşayanlar, sosyal kaygısı nedeniyle dışarı çıkmakta zorlananlar, seyahatte olanlar.",
      },
      {
        title: "Avantajları",
        body:
          "Zaman ve ulaşım tasarrufu; evinizin veya iş yerinizin konforunda güvenli ortam; esnek saat planlaması (hafta içi akşam, hafta sonu); süreklilik (tatil, iş seyahati, şehir değişimi gibi durumlarda bile seanslar kesintisiz sürer); mahremiyet (bekleme odası stresi yok).",
      },
      {
        title: "Online Seansa Hazırlık",
        body:
          "Sakin ve izole bir oda, stabil internet bağlantısı, kulaklık, kamera açık olacak şekilde cihazınız. İlk görüşmeden önce teknik testi birlikte yapıyoruz. Seans bağlantısı randevu saatinden önce size iletilir.",
      },
    ],
  },
};

// Niş / Hizmet bazlı landing page'ler (Google Ads için şart)
export const nicheLanding = {
  "antalya-emdr-terapi": {
    slug: "antalya-emdr-terapi",
    ilce: "EMDR · Antalya",
    h1: "Antalya EMDR Terapi — Avrupa Akredite Uygulayıcı",
    title: "Antalya EMDR Terapi | Uzm. Klinik Psk. Aysun Şeremet - Travma İşleme",
    description:
      "⭐ 4.8/75+ yorum. Antalya'da EMDR Avrupa Akredite Uygulayıcısı Aysun Şeremet ile travma, PTSD, panik atak ve kaygı süreçlerinde EMDR terapisi. Online & yüz yüze.",
    keywords:
      "antalya emdr, antalya emdr terapi, emdr avrupa akredite antalya, antalya travma terapisi, antalya ptsd, emdr psikolog antalya, antalya panik atak emdr",
    heroIntro:
      "Yaşanılmış ama tamamlanmamış duygusal yüklerin beyinde yeniden işlenmesini sağlayan EMDR; travma, kaygı ve takıntılı düşüncelerde kanıta dayalı en etkili yöntemlerden biridir.",
    lat: 36.8662,
    lng: 30.7260,
    areaServed: ["Muratpaşa", "Konyaaltı", "Kepez", "Aksu", "Online Türkiye"],
    sections: [
      {
        title: "EMDR Nedir?",
        body:
          "EMDR (Eye Movement Desensitization and Reprocessing — Göz Hareketleriyle Duyarsızlaştırma ve Yeniden İşleme) Dr. Francine Shapiro tarafından geliştirilen, Dünya Sağlık Örgütü tarafından travma tedavisinde önerilen kanıta dayalı bir psikoterapi yöntemidir. EMDR; zihnin kendi doğal iyileşme mekanizmasını devreye sokarak, yaşanmış ama beyinde tam işlenmemiş anıların (travmatik veya rahatsız edici deneyimlerin) duygusal yükünü azaltmayı hedefler.",
      },
      {
        title: "Hangi Durumlarda Etkilidir?",
        body:
          "Travma sonrası stres bozukluğu (TSSB), panik atak, yaygın kaygı bozukluğu, sosyal fobi, takıntılı düşünceler, yas ve kayıp süreçleri, bağlanma sorunları, çocukluk çağı olumsuz deneyimleri, performans kaygısı, düşük özgüven ve sürekli aynı örüntüde ilişki sorunları. Araştırmalar EMDR'ın PTSD'de 8-12 seansta anlamlı iyileşme sağladığını göstermektedir.",
      },
      {
        title: "Süreç Nasıl İşler?",
        body:
          "EMDR 8 aşamalı standart bir protokol izler: öykü alma ve tedavi planı, hazırlık, değerlendirme, duyarsızlaştırma, yerleştirme, beden taraması, kapanış ve yeniden değerlendirme. İki yönlü uyaran (göz hareketi, dokunma veya ses) kullanılarak beynin her iki yarımküresi uyarılır. Danışan konuyu anlatmadan sadece dikkatini bedenine ve duygularına yöneltir — bu yöntem 'yeniden yaşamak' zorunda bırakmaz.",
      },
      {
        title: "Neden Uzm. Klinik Psikolog Aysun Şeremet?",
        body:
          "Aysun Şeremet EMDR Avrupa Akredite Uygulayıcı unvanına sahiptir; bu, sıradan bir EMDR eğitiminden ötesi — uluslararası denetim, vaka süpervizyonu ve sürekli mesleki gelişim gerektiren bir akreditasyondur. Çocuk ve ergenlerde de EMDR uygulama yetkinliğine sahiptir. Antalya'da online ve yüz yüze seanslar sunulmaktadır.",
      },
    ],
  },

  "antalya-sinav-kaygisi": {
    slug: "antalya-sinav-kaygisi",
    ilce: "Sınav Kaygısı · Antalya",
    h1: "Antalya Sınav Kaygısı Psikolog — YKS · LGS · KPSS Desteği",
    title: "Antalya Sınav Kaygısı Psikolog | YKS LGS KPSS Desteği - Aysun Şeremet",
    description:
      "⭐ 4.8/75+ yorum. Antalya'da YKS, LGS, KPSS, ALES öncesi sınav kaygısı ile çalışan Uzm. Klinik Psk. Aysun Şeremet. EMDR, BDT ve nefes teknikleri ile kanıta dayalı destek.",
    keywords:
      "antalya sınav kaygısı, antalya yks psikolog, antalya lgs psikolog, antalya kpss psikolog, sınav kaygısı terapi antalya, antalya ergen psikolog, test kaygısı antalya",
    heroIntro:
      "Sınava hazırlık sadece çalışmakla bitmiyor — performansını sergileyebilmek için zihninin de hazır olması gerekiyor. Antalya'da sınav kaygısı süreçlerinde bilimsel yöntemlerle yanındayım.",
    lat: 36.8662,
    lng: 30.7260,
    areaServed: ["Muratpaşa", "Konyaaltı", "Kepez", "Tüm Antalya", "Online Türkiye"],
    sections: [
      {
        title: "Sınav Kaygısı Nedir?",
        body:
          "Sınav kaygısı; değerlendirilme anında ortaya çıkan, bedende (çarpıntı, nefes darlığı, mide bulantısı, baş dönmesi), duygularda (panik, umutsuzluk, öfke) ve zihinde (boşalma hissi, yoğun kaygı düşünceleri, dikkat dağınıklığı) kendini gösteren bir yaygın kaygı biçimidir. Düşük/orta seviyede motive edici olabilir; ancak yoğun sınav kaygısı bilgiyi kullanma kapasitesini doğrudan bloke eder.",
      },
      {
        title: "Hangi Öğrencilere Destek Veriyoruz?",
        body:
          "LGS (8. sınıf), YKS (12. sınıf ve mezun), KPSS, ALES, DGS, tıpta uzmanlık sınavları (TUS/DUS/EUS), uluslararası sınavlar (IELTS, TOEFL, GRE). 14-30 yaş aralığındaki öğrencilerle bireysel çalışma; ayrıca ebeveynle işbirliği gerektiren daha genç öğrencilerde aile içi iletişim dinamikleri ele alınır.",
      },
      {
        title: "Kullanılan Yöntemler",
        body:
          "EMDR — geçmiş başarısızlık deneyimlerinin ve olumsuz iç seslerin işlenmesi. BDT (Bilişsel Davranışçı Terapi) — 'yetersizim', 'çakacağım' gibi felaketleştiren düşünce kalıplarının fark edilmesi ve yeniden yapılandırılması. Nefes ve gevşeme teknikleri — sınav anı için pratik beceriler. Zaman yönetimi ve motivasyon çalışmaları.",
      },
      {
        title: "Ne Zaman Başvurmak En İyi?",
        body:
          "İdeal olarak sınavdan 3-6 ay önce başlamak en etkili sonucu verir; ancak sınava 1-2 ay kala bile EMDR ve nefes teknikleriyle belirgin fark yaratılabilir. Sınav gecesi ve sınav günü için özel 'kriz yönetimi' seansları da uygulanabilir.",
      },
    ],
  },

  "antalya-cocuk-psikologu": {
    slug: "antalya-cocuk-psikologu",
    ilce: "Çocuk Psikoloğu · Antalya",
    h1: "Antalya Çocuk Psikoloğu — Theraplay ve Oyun Terapisi",
    title: "Antalya Çocuk Psikoloğu | Theraplay & Oyun Terapisi - Aysun Şeremet",
    description:
      "⭐ 4.8/75+ yorum. Antalya'da çocuk ve ergenlerde Theraplay, Deneyimsel Oyun Terapisi ve EMDR ile duygusal düzenleme, kaygı, uyum ve travma çalışmaları. Online & yüz yüze.",
    keywords:
      "antalya çocuk psikoloğu, antalya ergen psikolog, antalya oyun terapisi, antalya theraplay, antalya çocuk psikoloji, çocuk ergen psikolog antalya, antalya pedagog",
    heroIntro:
      "Çocuk ve ergenler; duygu ve deneyimlerini henüz sözcüklerle dile getiremeyebilir. Oyun, metaforlar ve bedensel deneyim yoluyla içsel dünyalarını anlayıp, güvenli bağlanma ve duygu düzenleme becerileri kazandırıyoruz.",
    lat: 36.8662,
    lng: 30.7260,
    areaServed: ["Muratpaşa", "Konyaaltı", "Kepez", "Tüm Antalya", "Online Türkiye"],
    sections: [
      {
        title: "Kullanılan Yöntemler",
        body:
          "Theraplay — ebeveyn-çocuk bağlanmasını güçlendiren, yapılandırma, beslenme (nurture), meydan okuma ve işlenme boyutları ile etkileşimsel bir terapi. Deneyimsel Oyun Terapisi — çocuğun kendi iç dünyasını oyuncaklar ve sembollerle ifade ettiği, terapistin yargısız eşlik ettiği süreç. EMDR (çocuk protokolü) — travma sonrası stres, kazalar, kayıplar ve yoğun korkularda. BDT (yaşa uyarlı) — kaygı ve davranış sorunlarında.",
      },
      {
        title: "Hangi Yaşlarla Çalışıyoruz?",
        body:
          "3-18 yaş arası çocuk ve ergenlerle çalışıyoruz. 3-6 yaş: oyun terapisi ve ebeveyn çalışması birlikte. 6-12 yaş: bireysel oyun ve söz temelli çalışma + ebeveyn danışmanlığı. 12-18 yaş (ergen): bireysel psikoterapi, gerektiğinde aile seansı. Gerektiğinde kreş, anaokulu veya okul psikolojik danışmanıyla işbirliği yapılır.",
      },
      {
        title: "Sık Karşılaşılan Başvuru Nedenleri",
        body:
          "Uyum sorunları (kreş, okul, taşınma), kaygı ve fobik tepkiler (ayrılık, karanlık, hayvan, sınav), öfke nöbetleri, uyku ve yeme sorunları, tuvalet eğitimi ve enürezis, boşanma sürecine uyum, yas, kardeş doğumu, dikkat dağınıklığı, akran çatışmaları, akademik kaygı, öz saygı sorunları, ergenlik kimlik süreçleri.",
      },
      {
        title: "Ebeveyn Desteği",
        body:
          "Çocuk terapisinde ebeveyn işbirliği sürecin temel taşıdır. Belirli aralıklarla ebeveyn seansları düzenlenir; ebeveynin kendi tepkilerini, kaygılarını ve çocukla etkileşimini fark etmesi desteklenir. Gerektiğinde evde uygulanabilecek oyun/etkileşim önerileri sunulur.",
      },
    ],
  },
};

export const nicheListesi = Object.values(nicheLanding);
export const ilceListesi = Object.values(ilceler);

// Hem ilçe hem niş landing page'ler — IlcePsikolog component tarafından kullanılır
export const allLanding = { ...ilceler, ...nicheLanding };
